import { zodResolver } from '@hookform/resolvers/zod'
import { useAtom } from 'jotai'
import { useContext } from 'react'
import { useForm } from 'react-hook-form'

import { authenticationService } from '@/domain/Authentication'
import { SignInDto } from '@/domain/Authentication/dtos/sign-in.dto'
import { SignInSchema } from '@/domain/Authentication/schemas/sign-in.schema'

import { CartContext } from '../../Cart.vm'
import { useAccountContext } from '@/contexts/account-context'

export const useViewModel = () => {
    const {
        cartActor: [, send],
    } = useContext(CartContext)

    const { customer, login } = useAccountContext()

    const form = useForm<SignInDto>({
        defaultValues: {
            email: '',
            password: '',
        },
        resolver: zodResolver(SignInSchema),
    })

    const onSubmit = form.handleSubmit(async (data) => {
        try {
            if (!!customer) return
            // We uses this function because it's the only one that can also return the shipping_addresses of the customer
            await login(data)
            send({ type: 'NEXT' })
        } catch (err) {
            form.setError('email', {
                type: 'manual',
                message:
                    'Il semble que les informations de connexion soient incorrectes ou inexistantes.',
            })
        }
    })

    const onRegisterAccount = () => {
        send({
            type: 'AUTH.REGISTER',
        })
    }

    const onAnonymous = () => {
        send({
            type: 'AUTH.ANONYMOUS',
        })
    }

    return {
        control: form.control,
        onSubmit,
        onRegisterAccount,
        onAnonymous,
    }
}
